import { Box } from '@mui/material';
import useSettings from 'hooks/useSettings';

import { ReactNode } from 'react';

const CustomPaper = ({ children }: { children: ReactNode }) => {
  const { themeMode, themeDirection } = useSettings();
  const isLight = themeMode === 'light';
  return (
    <Box sx={{ backgroundColor: isLight ? '#ffff' : '#1c252e', p: 3, borderRadius: 2 }}>
      {children}
    </Box>
  );
};

export default CustomPaper;
